import React from 'react';
import { graphql } from 'gatsby';

import WritingPage from './writing';

// /writing is the canonical route. /blog is kept permanently so that every
// existing link, including the ones in published post bodies, keeps resolving.
const BlogAliasPage = (props) => <WritingPage {...props} />;

export default BlogAliasPage;
export const pageQuery = graphql`
  {
    allMarkdownRemark(sort: { fields: [frontmatter___date_created], order: DESC }) {
      edges {
        node {
          html
          frontmatter {
            date_created
            path
            tags
            title
            summary
            draft
          }
        }
      }
    }
  }
`;
